import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink border-t border-white/10" data-id="element-63" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center pt-[28px]" data-id="element-64" data-mp="3gh3q6bfwg0dk">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="32pfgeet4hnzr">
          Protocolo 3C<span className="align-super text-xs" data-id="element-66" data-mp="36qhdoq3hbpz3">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3ufa6idot1hph">
          El sistema N°1 para hombres que quieren pasar del chat a la cita en Argentina. Porque
          chatear sin dirección no debería costarte más oportunidades.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3lggc8tyy53f3">
          <a href="mailto:soporte.protocolo3c@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-69" data-mp="3qf9suv9j5ajh">
            <MailIcon className="h-4 w-4 text-azul-soft" data-id="element-70" data-mp="2eyjqxoc534vo" /> soporte.protocolo3c@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-71" data-mp="3l8qwo57filrz">
            <InstagramIcon className="h-4 w-4 text-azul-soft" data-id="element-72" data-mp="3gb8xh6j7rkx6" /> @protocolo3c
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-73" data-mp="3v89fujfim3iz">
            <GlobeIcon className="h-4 w-4 text-azul-soft" data-id="element-74" data-mp="3q8dkf8kvvkf1" /> www.protocolo3c.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-gold" data-id="element-75" data-mp="81yvkel2tq1v">
          “La próxima cita empieza en el próximo mensaje.” 📲
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="31uoff6267ob">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="huwgerdjjr3n">Términos y condiciones</a>
          <span data-id="element-78" data-mp="cvtng5au5bc1">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="qt8ibpjuybbe">Política de privacidad</a>
          <span data-id="element-80" data-mp="mrwmh2ae4tur">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="mspoxr2bgx73">Soporte</a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="tvw6yepkdbex">
          © 2026 Protocolo 3C™ — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}